import React from "react";
import CM_pragati_yatra from "./../../assets/CM pragati yatra.svg";

export const CmPragatiYatra = ({ className, isValidProject }) => {
  return isValidProject ? (
    <div className={className}>
      <img src={CM_pragati_yatra} />
    </div>
  ) : null;
};
